function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.11111 13.1111H9.77778C10.3889 13.1111 10.8889 12.6111 10.8889 12V3.11111C10.8889 2.5 10.3889 2 9.77778 2H3.11111C2.5 2 2 2.5 2 3.11111V12C2 12.6111 2.5 13.1111 3.11111 13.1111ZM3.11111 22H9.77778C10.3889 22 10.8889 21.5 10.8889 20.8889V16.4444C10.8889 15.8333 10.3889 15.3333 9.77778 15.3333H3.11111C2.5 15.3333 2 15.8333 2 16.4444V20.8889C2 21.5 2.5 22 3.11111 22ZM14.2222 22H20.8889C21.5 22 22 21.5 22 20.8889V12C22 11.3889 21.5 10.8889 20.8889 10.8889H14.2222C13.6111 10.8889 13.1111 11.3889 13.1111 12V20.8889C13.1111 21.5 13.6111 22 14.2222 22ZM13.1111 3.11111V7.55556C13.1111 8.16667 13.6111 8.66667 14.2222 8.66667H20.8889C21.5 8.66667 22 8.16667 22 7.55556V3.11111C22 2.5 21.5 2 20.8889 2H14.2222C13.6111 2 13.1111 2.5 13.1111 3.11111Z",
  fill: "#B8C8CC"
});

var SvgDistribution = function SvgDistribution(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDistribution, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/distribution.04d546f2.svg";
export { ForwardRef as ReactComponent };